import { render, staticRenderFns } from "./FormNoteBlock.vue?vue&type=template&id=6defbf0e"
import script from "./FormNoteBlock.vue?vue&type=script&lang=js"
export * from "./FormNoteBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports